const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Named templates for routes whose dynamic segment is NOT a UUID (slugs,
// opaque tokens) — the UUID fallback below already collapses UUID-shaped
// segments, so only non-UUID params need an explicit entry. Keep this list
// in sync with main.tsx routes when params change shape.
const TEMPLATES: Array<{ pattern: RegExp; template: string }> = [
  { pattern: /^\/invite\/[^/?#]+$/, template: "/invite/:token" },
  { pattern: /^\/share\/[^/?#]+$/, template: "/share/:token" },
  { pattern: /^\/agents\/[^/?#]+$/, template: "/agents/:slug" },
  { pattern: /^\/admin\/inbox\/feedback\/[^/?#]+$/, template: "/admin/inbox/feedback/:id" },
  // Retired path; still hit once by old Slack links before AdminView redirects.
  { pattern: /^\/admin\/feedback\/[^/?#]+$/, template: "/admin/feedback/:id" },
];

export function normalizePath(fullPath: string): string {
  const pathOnly = fullPath.split("?")[0]!.split("#")[0]!;
  for (const { pattern, template } of TEMPLATES) {
    if (pattern.test(pathOnly)) return template;
  }
  const segments = pathOnly.split("/");
  const normalized = segments
    .map((seg) => (UUID_RE.test(seg) ? ":id" : seg))
    .join("/");
  return normalized;
}
